<template>
  <tr :class="{ 'mdm-data-row--alt': rowIndex % 2 === 1 }">
    <td class="text-center action-col">
      <div class="mdm-action-toolbar" role="toolbar" aria-label="Row actions">
        <button
            v-if="rowd.syspk !== editableId"
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-add"
            title="Insert new record after this row"
            aria-label="Insert new record after this row"
            :disabled="blockRowActionsForVeeOrPolicy"
            @click="$emit('add', rowd.syspk)"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        <button
            v-if="rowd.syspk !== editableId"
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-edit"
            title="Edit this row"
            aria-label="Edit this row"
            :disabled="blockRowActionsForVeeOrPolicy"
            @click="$emit('edit', rowd.syspk)"
        >
          <i class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <button
            v-if="showInputfield && rowd.syspk === editableId"
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-save"
            title="Save changes"
            aria-label="Save changes"
            :disabled="disableSaveDraftForVee"
            @click="$emit('save-edit')"
        >
          <i class="fas fa-check" aria-hidden="true"></i>
        </button>
        <button
            v-if="showInputfield && rowd.syspk === editableId"
            type="button"
            class="mdm-toolbar-btn mdm-toolbar-btn-cancel"
            title="Cancel editing"
            aria-label="Cancel editing"
            @click="$emit('cancel', rowd)"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </td>
    <td
        v-for="(col, i) in rcolumns"
        :key="col"
        :class="{
          'text-right': col.startsWith('rm'),
          'text-left': col.startsWith('rd') || col.startsWith('rr'),
          'text-danger': rowd['rm7'] > 40,
          'multi-line-cell': !fr.mdmIsStickyAnchorDisplayName(columns[i]),
          'textarea-cell': columnsInfo[i]['fieldValidationType'] === 'textarea',
          'sno-col': fr.mdmIsStickyAnchorDisplayName(columns[i]),
          'sticky-follow-col': cellLayout.flags[i],
        }"
        :style="cellLayout.styles[i]"
    >{{ rowd[col] }}</td>
  </tr>
</template>

<script>
export default {
  name: 'MdmFormReportDataRow',
  inject: ['mdmFormReport'],
  props: {
    rowd: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    rcolumns: {
      type: Array,
      required: true,
    },
    columnsInfo: {
      type: Array,
      required: true,
    },
    editableId: {
      type: [String, Number, Array, Object],
      default: null,
    },
    showInputfield: {
      type: [Boolean, String],
      default: false,
    },
    /** Precomputed in parent so it does not depend on draft row state (rowEdit / rowInsert). */
    cellLayout: {
      type: Object,
      required: true,
      validator(v) {
        return v && Array.isArray(v.flags) && Array.isArray(v.styles)
      },
    },
    rowActionsEnabled: {
      type: Boolean,
      default: true,
    },
    mdmVeeInvalid: {
      type: Boolean,
      default: false,
    },
    mdmDraftActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fr() {
      return this.mdmFormReport
    },
    /** Block add/edit while another insert/edit draft has failing vee-validation, or when policy disallows actions. */
    blockRowActionsForVeeOrPolicy() {
      if (!this.rowActionsEnabled) {
        return true
      }
      return !!(this.mdmVeeInvalid && this.mdmDraftActive)
    },
    disableSaveDraftForVee() {
      return !!(this.mdmVeeInvalid && this.showInputfield && this.rowd.syspk === this.editableId)
    },
  },
}
</script>
